import { render } from "./ProfilPegawai.vue?vue&type=template&id=1321ef73"
import script from "./ProfilPegawai.vue?vue&type=script&lang=js"
export * from "./ProfilPegawai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__